"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubDejaSouscritQuandCorporation = void 0;
exports.ESubDejaSouscritQuandCorporation = {
    more_than_a_year_ago: "more_than_a_year_ago",
    less_than_a_year_ago: "less_than_a_year_ago",
};
